"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFieldWithLabel = exports.TextField = void 0;
var core_1 = require("@blueprintjs/core");
var React = require("react");
var TextField = function (props) { return (React.createElement(core_1.InputGroup, { autoFocus: props.autoFocus, type: "text", readOnly: props.readOnly, id: props.id, intent: props.error ? core_1.Intent.DANGER : core_1.Intent.NONE, className: "bp3-fill ".concat(props.large ? 'bp3-large' : '', " ").concat(props.className), leftIcon: props.leftIcon, value: props.value ? props.value : undefined, onChange: function (e) { return props.onChange(e.target.value); }, placeholder: props.placeholder, rightElement: props.rightElement, disabled: props.disabled })); };
exports.TextField = TextField;
var TextFieldWithLabel = function (props) { return (React.createElement(core_1.FormGroup, { inline: props.inline, intent: props.error ? core_1.Intent.DANGER : core_1.Intent.NONE, label: React.createElement("span", { className: "f5 fw5" }, props.label), contentClassName: props.contentClassName ? props.contentClassName : '', helperText: props.error ? props.error : props.helperText, labelFor: props.id },
    React.createElement(exports.TextField, __assign({}, props)))); };
exports.TextFieldWithLabel = TextFieldWithLabel;
//# sourceMappingURL=TextField.js.map